import { businessListUrlGenerator, fetchBusinessList } from 'api'
import { ServiceListData } from 'components/common/types'
import useSWR from 'swr'

const useRestaurants = ({
  regionId,
  serviceId,
  latitude,
  longitude,
  onSuccess
}) => {
  let businessListUrl = businessListUrlGenerator({
    regionId,
    serviceId,
    isGeolocationUsed: !!latitude
  })

  const {
    data,
    mutate: setRestaurantsData,
    error
  } = useSWR<ServiceListData>(
    businessListUrl,
    () =>
      fetchBusinessList({
        regionId,
        serviceId,
        latitude,
        longitude
      }),
    {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      errorRetryCount: 1,
      onSuccess,
      dedupingInterval: 1000
    }
  )

  return {
    isLoading: !error && !data,
    restaurants: data,
    setRestaurantsData
  }
}

export default useRestaurants
